import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import FormatHour from '@shared/containers/FormatHour';

import messages from './messages';

const Message = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};
  text-align: center;
  color: ${({ theme }) => theme.colors.night_blue_1};
  background: ${({ theme }) => theme.colors.limon_lighter_1};
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(3, 3, 0, 0)};
  text-transform: uppercase;
`;

function OpenIn({ nextHour, className }) {
  return (
    <>
      <FormattedMessage {...messages.openIn}>
        {message => (
          <Message className={className}>
            {`${message} `}
            <FormatHour value={nextHour} />
          </Message>
        )}
      </FormattedMessage>
    </>
  );
}

OpenIn.defaultProps = {
  className: '',
};

OpenIn.propTypes = {
  nextHour: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default OpenIn;
